import { memo } from 'react';
import { Typography } from 'antd';

import { Auction, AuctionSummary } from 'models/auction/Auction';
import { unixTimestampMsToLocaleString } from 'utils/date';

import TitleDescriptionList from './TitleDescriptionList';

const { Title } = Typography;

interface AuctionScheduleProps {
  auction: Auction | AuctionSummary;
}

function AuctionSchedule({ auction }: AuctionScheduleProps) {
  const schedules = [
    {
      key: 'startsAt',
      title: '시작 날짜',
      description: unixTimestampMsToLocaleString(auction.starts_at),
    },
    {
      key: 'endsAt',
      title: '종료 날짜',
      description: unixTimestampMsToLocaleString(auction.ends_at),
    },
  ];

  return (
    <>
      <Title level={4}>경매 일정</Title>
      <TitleDescriptionList datalist={schedules} />
    </>
  );
}

export default memo(AuctionSchedule);
